module.exports = __webpack_public_path__ + "static/media/houseSolid.28653321.svg";